// extracted by mini-css-extract-plugin
export default {"stars":"product-list-filter__stars___YQJyS","category-placeholder":"product-list-filter__category-placeholder___15I1d","tooltip":"product-list-filter__tooltip___TYVtr"};